document.addEventListener('DOMContentLoaded',()=>{const buttons=document.querySelectorAll('[data-menu-toggle]');const menu=document.querySelector('[data-mega-menu]');buttons.forEach(button=>button.addEventListener('click',()=>menu?.classList.toggle('open')));});

// Brand directory: optional A-Z grouping + live search
document.addEventListener('DOMContentLoaded',()=>{
  const input=document.querySelector('[data-brand-search]');
  const grid=document.querySelector('[data-brand-grid]');
  if(!grid) return;
  const tiles=[...grid.querySelectorAll('[data-brand-name]')];
  const emptyMsg=document.querySelector('[data-brands-empty]');
  if(emptyMsg) emptyMsg.style.display=tiles.length?'none':'block';
  const countEl=document.querySelector('[data-brands-count]');
  if(countEl&&tiles.length) countEl.textContent=tiles.length===1?'1 brand':tiles.length+' brands';
  if(grid.hasAttribute('data-group-az')){
    const azNav=document.querySelector('[data-brands-az]');
    tiles.sort((a,b)=>a.getAttribute('data-brand-name').localeCompare(b.getAttribute('data-brand-name'),undefined,{sensitivity:'base'}));
    const groups={};
    tiles.forEach((t)=>{
      let ch=((t.getAttribute('data-brand-name')||'').trim()[0]||'#').toUpperCase();
      if(!/[A-Z]/.test(ch)) ch='#';
      (groups[ch]=groups[ch]||[]).push(t);
    });
    const letters=Object.keys(groups).sort();
    if(azNav){
      letters.forEach((L)=>{
        const a=document.createElement('a');
        a.href='#brand-'+L;
        a.textContent=L;
        azNav.appendChild(a);
      });
    }
    grid.innerHTML='';
    letters.forEach((L)=>{
      const sec=document.createElement('div');
      sec.className='brands-section';
      sec.id='brand-'+L;
      const h=document.createElement('h2');
      h.textContent=L;
      sec.appendChild(h);
      const g=document.createElement('div');
      g.className='brand-grid';
      groups[L].forEach((t)=>g.appendChild(t));
      sec.appendChild(g);
      grid.appendChild(sec);
    });
  }
  if(!input) return;
  const noResults=document.querySelector('[data-brands-no-results]');
  input.addEventListener('input',()=>{
    const q=input.value.trim().toLowerCase();
    let any=false;
    grid.querySelectorAll('[data-brand-name]').forEach((tile)=>{
      const name=(tile.getAttribute('data-brand-name')||'').toLowerCase();
      const co=(tile.getAttribute('data-company')||'').toLowerCase();
      const show=!q||name.includes(q)||co.includes(q);
      tile.style.display=show?'':'none';
      if(show) any=true;
    });
    grid.querySelectorAll('.brands-section').forEach((sec)=>{
      const vis=[...sec.querySelectorAll('[data-brand-name]')].some((t)=>t.style.display!=='none');
      sec.style.display=vis?'':'none';
    });
    if(noResults) noResults.style.display=any?'none':'block';
  });
  // Deep link: ?company=Name pre-fills the search (used by product page company links)
  const cq=new URLSearchParams(location.search).get('company');
  if(cq){ input.value=cq; input.dispatchEvent(new Event('input')); }
});

// Scroll reveal animations (gated by the Animations theme setting via body.anim-off)
(function(){
  var els = document.querySelectorAll('[data-reveal]:not(.revealed)');
  if(!els.length) return;
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('revealed')}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('revealed'); io.unobserve(en.target); } });
  }, {threshold: 0.12});
  els.forEach(function(e){ io.observe(e); });
})();
